import Reveal from "@/components/Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "Craft",
    body: "Dobby and jacquard looms run by hands that learned from their parents. We weave slowly, because towels remember how they were made.",
  },
  {
    n: "02",
    title: "Material",
    body: "Long-staple Aegean cotton, combed and ring-spun. Chosen for absorbency that deepens with every wash instead of fading from it.",
  },
  {
    n: "03",
    title: "Partnership",
    body: "OEM and private label, from first sample to container load. Hotels, spas and brands across Europe trust us with their name on the label.",
  },
];

export default function Manifesto() {
  return (
    <section data-testid="manifesto-section" className="bg-night text-cream py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal>
          <p className="text-[11px] uppercase tracking-[0.3em] font-semibold text-clay mb-6">
            03 — Manifesto
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-serif font-light tracking-tight leading-[1.05] text-4xl sm:text-5xl lg:text-6xl max-w-3xl">
            What we believe,
            <em className="italic text-clay"> in three threads.</em>
          </h2>
        </Reveal>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={0.12 * i}>
              <div data-testid={`manifesto-chapter-${c.n}`} className="relative pt-10 border-t border-cream/15">
                <span className="font-serif text-outline-light text-7xl sm:text-8xl absolute -top-9 left-0 select-none">
                  {c.n}
                </span>
                <h3 className="font-serif italic text-3xl mt-8 mb-4">{c.title}</h3>
                <p className="text-cream/65 text-sm sm:text-base leading-relaxed">{c.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
